/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateCustomerTankRequest model module.
* @module model/CreateCustomerTankRequest
* @version 2020-12-7
*/
export default class CreateCustomerTankRequest {
    /**
    * Constructs a new <code>CreateCustomerTankRequest</code>.
    * 顧客タンク登録リクエスト
    * @alias module:model/CreateCustomerTankRequest
    * @class
    * @param tankType {Number} 
    * @param remarks {String} 
    * @param volumeThreshold {Number} 
    * @param deliveryFrequency {Number} 
    */

    constructor(tankType, remarks, volumeThreshold, deliveryFrequency) {
        
        
        this['tankType'] = tankType;
        this['remarks'] = remarks;
        this['volumeThreshold'] = volumeThreshold;
        this['deliveryFrequency'] = deliveryFrequency;
        
    }

    /**
    * Constructs a <code>CreateCustomerTankRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerTankRequest} obj Optional instance to populate.
    * @return {module:model/CreateCustomerTankRequest} The populated <code>CreateCustomerTankRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerTankRequest();
                        
            
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
            if (data.hasOwnProperty('tankType')) {
                obj['tankType'] = ApiClient.convertToType(data['tankType'], 'Number');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('volumeThreshold')) {
                obj['volumeThreshold'] = ApiClient.convertToType(data['volumeThreshold'], 'Number');
            }
            if (data.hasOwnProperty('deliveryFrequency')) {
                obj['deliveryFrequency'] = ApiClient.convertToType(data['deliveryFrequency'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {String} serialNo
    */
    'serialNo' = undefined;
    /**
    * @member {Number} tankType
    */
    'tankType' = undefined;
    /**
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * @member {Number} volumeThreshold
    */
    'volumeThreshold' = undefined;
    /**
    * @member {Number} deliveryFrequency
    */
    'deliveryFrequency' = undefined;




}
